import * as React from "react";
const CreateUnplannedRequestView = React.lazy(() => import("./CreateUnplannedRequestViewContainer"));

export { CreateUnplannedRequestView };
